import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { truncate } from 'flarum/common/utils/string';
export default class DocumentRequestNotification extends Notification {
  icon() {
    return 'fas fa-file-pdf';
  }
  href() {
    return app.route('val-moderation') + '?tab=documents';
  }
  content() {
    const notification = this.attrs.notification;
    const user = notification.fromUser();
    return m('span', [user ? m('strong', user.displayName()) : m('strong', 'Un membre'), ' a demandé une documentation']);
  }
  excerpt() {
    const post = this.attrs.notification.subject();
    return post ? truncate(post.contentPlain(), 200) : '';
  }
}